import { render } from "./AudioVisual.vue?vue&type=template&id=5cf653da"
import script from "./AudioVisual.vue?vue&type=script&lang=js"
export * from "./AudioVisual.vue?vue&type=script&lang=js"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__